<template>
  <div>
    <vs-card v-if="!isLoading">
      <FormImportLeads
        :idUsuarioUpload="idUsuarioUpload"
        @refreshList="refreshList"
      />

      <ListImportacoes
        :key="listImportacoesKey"
        :idUsuarioUpload="idUsuarioUpload"
        :listImportacoes="listImportacoes"
      />
    </vs-card>
  </div>
</template>

<script>
import FormImportLeads from './components/FormImportLeads.vue';
import ListImportacoes from './components/ListImportacoes.vue';
import leadsService from './service/index';
import notify from '../../../../utils/notify';

import jwt from 'jsonwebtoken';
import moment from 'moment';

export default {
  components: {
    FormImportLeads,
    ListImportacoes,
  },
  data() {
    return {
      isLoading: true,
      idUsuarioUpload: null,
      listImportacoes: [],
      listImportacoesKey: 0, // Variável para controlar a chave do componente ListImportacoes
    };
  },

  methods: {
    getUser() {
      const token = localStorage.getItem('user-token');
      this.idUsuarioUpload = jwt.decode(token).id_usuario;
    },

    async getImportacoes() {
      try {
        this.$vs.loading();
        const result = await leadsService.getImportacoes(this.idUsuarioUpload);

        const arrayImportacoes = [];

        result.forEach((item) => {
          const anoMesReferencia = this.formataAnoMes(
            item.anoReferente,
            item.mesReferente,
          );

          const dataUpload = this.formatDataUpload(item.createdAt);

          arrayImportacoes.push({
            ...item,
            anoMesReferencia: anoMesReferencia,
            dataUpload: dataUpload,
          });
        });

        this.listImportacoes = arrayImportacoes;
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },

    formataAnoMes(ano, mes) {
      const mesFormatado =
        mes.toString().length == 1 ? '0' + mes.toString() : mes.toString();
      const anoFormatado = ano.toString();
      return `${anoFormatado}/${mesFormatado}`;
    },

    formatDataUpload(date) {
      return moment(date).format('DD/MM/YYYY');
    },

    async start() {
      this.getUser();
      await this.getImportacoes();
      this.isLoading = false;
    },

    refreshList() {
      this.getImportacoes(); // Busca os registros atualizados
      this.listImportacoesKey += 1; // Incrementa a chave do componente ListImportacoes para recriá-lo
    },
  },
  mounted() {
    this.start();
  },
};
</script>
